import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Traveler, TravelerFilter } from '../../../../core/models/organization.interface';

import _ from 'lodash'; // If using lodash
import { OrganizationUtilService } from '../../../../core/services/organization-util.service';
import { TravelersService } from '../../../../core/services/travelers.service';
import { IllumPolygonCreatorService } from '../../../../core/services/Illum-polygon-creator.service';
import { GlobalSettingsService } from '../../../../core/services/global-settings.service';

@Component({
  selector: 'app-travelers-list',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule],
  templateUrl: './travelers-list.component.html',
  styleUrl: './travelers-list.component.css'
})
export class TravelersListComponent implements OnInit {
  travelers: Traveler[] = [];
  organizations: any[] = [];
  dateRanges: any[] = [];
  searchForm: FormGroup;
  allChecked = false;
  isLoading = false;

  availableIndexTextShow: string[] = [];
  allIndexText: string[] = [];

  constructor(
    private fb: FormBuilder,
    private organizationUtilService: OrganizationUtilService,
    private travelerService: TravelersService,
    private illumPolygonCreator: IllumPolygonCreatorService,
    private globalSettings: GlobalSettingsService,
  ) {
    this.searchForm = this.fb.group({
      organization: [''],
      dateRange: [''],
      searchText: ['']
    });
  }

  ngOnInit() {
    this.loadInitialData();
    this.setupSearchListener();
  }

  private loadInitialData() {
    this.isLoading = true;

    const orgs = _.orderBy(
      _.map(this.organizationUtilService.myOrgs, (org: any) => ({
        label: org.name,
        id: org.id,
        title: org.name
      })),
      ['label']
    );
    const all = { label: 'All', id: '-1', title: 'All' };
    this.organizations = [all, ...orgs];

    this.searchForm.patchValue({ organization: this.organizations[0].id });

  // Date Ranges
  this.dateRanges = [
    { label: 'Today', dayDiff: 0 },
    { label: 'Next 7 Days', dayDiff: 7 },
    { label: 'Next 30 Days', dayDiff: 30 },
    { label: 'Past 7 Days', dayDiff: -7 },
    { label: 'Past 30 Days', dayDiff: -30 }
  ];
  // Set default to "Next 30 Days"
  this.searchForm.patchValue({ dateRange: this.dateRanges[2].dayDiff });

    this.isLoading = false;
  }

  private setupSearchListener() {
    this.searchForm.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe(() => {
        this.loadTravelers();
      });
  }

  loadTravelers() {
    this.isLoading = true;
    const filter: TravelerFilter = this.searchForm.value;

    // this.travelerService.getTravelers(filter)
    //   .subscribe({
    //     next: (travelers) => {
    //       this.travelers = travelers || [];
    //       // Optionally, build allIndexText for typeahead
    //       this.allIndexText = this.buildAllIndexText(this.travelers);
    //       this.updateAllChecked();
    //     },
    //     error: (error) => {
    //       console.error('Error loading travelers:', error);
    //     },
    //     complete: () => {
    //       this.isLoading = false;
    //     }
    //   });
  }

  // Build a unique, sorted list of all search terms for typeahead
  private buildAllIndexText(travelers: Traveler[]): string[] {
    const terms = new Set<string>();
    travelers.forEach(t => {
      // if (t.searchTerms && Array.isArray(t.searchTerms)) {
      //   t.searchTerms.forEach(term => terms.add(term));
      // }
    });
    return Array.from(terms).sort();
  }

  // For typeahead/autocomplete (optional)
  onSearchTextChanged() {
    const text = (this.searchForm.value.searchText || '').toLowerCase();
    if (!text || text.trim().length < 2) {
      this.availableIndexTextShow = [];
      return;
    }
    this.availableIndexTextShow = this.allIndexText.filter(item =>
      item.toLowerCase().includes(text)
    ).slice(0, 20);
  }

  clearSearchText() {
    this.searchForm.patchValue({ searchText: '' });
    this.loadTravelers();
  }

  onCheckAllChanged() {
    this.travelers.forEach(traveler => {
      traveler.checked = this.allChecked;
    });
  }

  onCheckItemChanged() {
    this.updateAllChecked();
  }

  private updateAllChecked() {
    this.allChecked = this.travelers.length > 0 &&
      this.travelers.every(traveler => traveler.checked);
  }

  onSendMessage() {
    const selectedTravelers = this.travelers
      .filter(t => t.checked)
      .map(t => t.id);

    if (selectedTravelers.length === 0) {
     
      return;
    }
  }

  onViewTravelerDetails(traveler: Traveler) {
    // Implement navigation to details view or open modal
  }
}